import * as React from "react";
import { PrismicPreviewProvider } from "gatsby-plugin-prismic-previews";

import { linkResolver } from "./src/linkResolver";

export const wrapRootElement = ({ element }) => (
  <PrismicPreviewProvider
    repositoryConfigs={[
      {
        repositoryName: process.env.GATSBY_PRISMIC_REPO_NAME,
        linkResolver,
        componentResolver: {
          page: React.lazy(() => import("./src/pages/{PrismicPage.url}.js")),
        },
      },
    ]}
  >
    {element}
  </PrismicPreviewProvider>
);
